export const ArticleOGImageType = {
  analysis: "og_image_scmp_analysis",
  editorial: "og_image_scmp_editorial",
  explainer: "og_image_scmp_explainer",
  factCheck: "og_image_scmp_fact_check",
  generic: "og_image_scmp_generic",
  live: "og_image_scmp_live",
  obituary: "og_image_scmp_obituary",
  opinion: "og_image_scmp_opinion",
  postmag: "og_postmag",
  review: "og_image_scmp_review",
  series: "og_image_scmp_series",
  style: "og_image_style",
} as const;

export type ValueOfArticleOGImageType =
  (typeof ArticleOGImageType)[keyof typeof ArticleOGImageType];

export const ExcludedArticleIds = [
  "1780152",
  "1781385",
  "1783122",
  "1782752",
  "1785202",
  "1786367",
  "1787941",
  "1788985",
  "1854626",
  "1855229",
  "1857242",
  "1862338",
  "1863178",
  "1863522",
  "1784494",
  "1815689",
  "1840168",
  "1840737",
  "1944555",
  "2057808",
  "1825585",
  "2116233",
  "3004217",
];
